<div class="content">
  @for (tag of tags(); track tag.id) {
    <i class="tag">
      <{{ tag.name }}>
    </i>
  }
</div>
